
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from '@/components/dashboard/products/components/LoadingSpinner';
import { AlertCircle } from 'lucide-react';

interface AuthCallbackContentProps {
  error: string | null;
  processing: boolean;
  handleManualRedirect: () => void;
}

export const AuthCallbackContent = ({ 
  error, 
  processing, 
  handleManualRedirect 
}: AuthCallbackContentProps) => {
  const navigate = useNavigate();

  if (error) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-pastel-blue-light">
        <div className="text-center p-6 bg-white rounded-lg shadow-md w-full max-w-md">
          <div className="flex justify-center mb-4 text-red-500">
            <AlertCircle size={48} />
          </div>
          <h2 className="text-xl font-semibold text-red-600">Erreur d'authentification</h2>
          <p className="mt-2 text-gray-600">{error}</p>
          <button 
            onClick={() => navigate('/login')} 
            className="mt-6 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            Retour à la page de connexion
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-pastel-blue-light">
      <div className="text-center">
        <LoadingSpinner />
        <h2 className="mt-6 text-xl font-semibold">Authentification en cours...</h2>
        <p className="mt-2 text-gray-600">Veuillez patienter pendant que nous vous connectons.</p>
        {processing && (
          <button 
            onClick={handleManualRedirect}
            className="mt-8 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
          >
            Accéder directement au tableau de bord
          </button>
        )}
      </div>
    </div>
  );
};
